import { apiGetUserInfo } from '$api';
import store from '@store';
import utils from 'blue-utils';
import config from '@config';
import programUrl from '@config/program-url';


export default function user() {
  setUserInfo();
}

//设置获取用户信息
function setUserInfo() {
  apiGetUserInfo().then((result) => {
    const { data } = result.data;
    if(utils.isArray(data)){
      store.commit('setUserInfo', {});
    } else {
      config.share.deps = data.share_content || config.share.deps;
      config.share.imgUrl = data.share_img || config.share.imgUrl;
      config.share.title = data.share_title || config.share.title;

      store.commit('setUserInfo', data);
    }
  });
}
